import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { shoper } from "@/lib/platforms-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/platformy/shoper";

export const Route = createFileRoute("/platformy/shoper")({
  head: () =>
    buildSeoMeta({
      title: "Wdrożenia Shoper — integracje Baselinker, marketplace, marketing | SyncTech",
      description:
        "Wdrożenia, migracje i optymalizacja sklepów Shoper. Integracje z Baselinker, Allegro, Amazon, kurierzy, GA4, Pixel, Google Ads. SEO i Core Web Vitals. Bezpłatna konsultacja.",
      path: PATH,
    }),
  component: () => <PlatformPage data={shoper} path={PATH} breadcrumbCategory="Platformy" />,
});
